<script lang="ts">
    import { getSeiten } from "../../api"
    import { sprache } from "../../store"
    import LadeAnimation from "../LadeAnimation.svelte"

    let ladeStellen = true
    let items: Seite[] = []

    getSeiten($sprache, null, "stellenangebot").then((r: Seite[]) => {
        items = r
        ladeStellen = false
    })
</script>

<div class="collection">
    {#if ladeStellen}
        <LadeAnimation />
    {:else}
        {#each items as stellenangebote}
            <a href="/{stellenangebote.pfad}" class="item">
                <span class="title">{stellenangebote.titel}</span>
                <span class="arrow"
                    ><img src="/media/arrow_right.svg" alt="" /></span
                >
            </a>
        {/each}
    {/if}
</div>

<style lang="less">
    @import "../../css/base.less";

    .item {
        display: block;
        position: relative;
        padding: 20px 0px;
        border-bottom: solid 1px #ccc;
        width: 100%;
        .title {
            color: @maincolor;
            font-size: 1.5rem;
            margin: 0px;
            @media (max-width: 768px) {
                font-size: 1.2rem;
            }
            &:before {
                display: none;
            }
        }
        .arrow {
            position: absolute;
            right: 10px;
            top: 0;
            bottom: 0;
            .flex();
            align-items: center;
            justify-content: center;
            width: 15px;
            height: auto;
            img {
                width: 100%;
                height: auto;
            }
        }
    }
</style>
